var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[_c('img',{staticClass:"mb-2 mr-2",attrs:{"src":"/assets/img/person.svg","width":"12","height":"12"}}),_c('a',{attrs:{"href":'/users/' + _vm.data.user.userId}},[_vm._v(_vm._s(_vm.data.user.userId))])])
}
var staticRenderFns = []

export { render, staticRenderFns }